<div class="d-flex gap-2 flex-wrap">
    <div *ngFor="let o of organizations$ | async">
        <div class="d-flex align-items-center">
            <label
                [for]="'organization_options_item' + o.id + ''"
                class="d-inline-flex gap-1 align-items-center ms-3 cursor-pointer"
            >
                <p-radioButton
                    [inputId]="'organization_options_item' + o.id + ''"
                    [value]="o.id"
                    [ngModel]="selectionModel.selected[0]"
                    (ngModelChange)="selectionModel.select($event); onTouchedFn?.()"
                    name="organizations-select"
                />
                <span>{{ o.name }}</span>
            </label>
        </div>
    </div>
    <div *ngIf="showNone">
        <div class="d-flex align-items-center">
            <label
                [for]="'organization_options_item_none'"
                class="d-inline-flex gap-1 align-items-center ms-3 cursor-pointer"
            >
                <p-radioButton
                    [inputId]="'organization_options_item_none'"
                    [value]="null"
                    [ngModel]="selectionModel.selected[0]"
                    (ngModelChange)="selectionModel.select($event); onTouchedFn?.()"
                    name="organizationss-select"
                />
                <span>无</span>
            </label>
        </div>
    </div>
</div>
